import React, { forwardRef } from 'react';
import { clsx } from 'clsx';

type Option = { value: string | number; label: string };

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options?: Option[]; // optional convenience API
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, className, children, options, ...rest }, ref) => {
    // Don't override onChange - let react-hook-form handle it
    // React-hook-form needs the event object, not just the value
    return (
      <div>
        {label && (
          <label htmlFor={(rest as any).id} className="block text-sm font-medium text-gray-700 mb-1">
            {label}
          </label>
        )}
        <select
          ref={ref}
          className={clsx(
            'w-full rounded-md shadow-sm',
            error
              ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500',
            className
          )}
          {...rest}
        >
          {options && options.length > 0
            ? options.map((opt) => (
                <option key={String(opt.value)} value={String(opt.value)}>
                  {opt.label}
                </option>
              ))
            : children}
        </select>
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
      </div>
    );
  }
);
